import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const ZoomMeetingService = {
  addZoomEvent,
  getZoomEventsByNodeMid,
  updateZoomEvent,
  deleteZoomEvent,
  getMembersListOfNode
};

async function addZoomEvent(meetingData) {
  try {
    const configOptions = {
      method: "POST",
      headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(meetingData),
    };

    const response = await fetch(
      `${config.oat_api_url}/manage/zoom-events/add-zoom-event`,
      configOptions
    );

    return APIHandler.handleResponse(response);
  } catch (error) {
    console.error("Error creating Zoom meeting:", error);
    throw new Error("Failed to create Zoom meeting");
  }
}

async function getZoomEventsByNodeMid(nodeMid) {
  try {
    if (!nodeMid) {
      throw new Error("Node MID is required");
    }

    const requestOptions = {
      method: "GET",
      headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    };

    const response = await fetch(
      `${config.oat_api_url}/manage/zoom-events/get-zoom-events-by-node-mid?node_mid=${nodeMid}`,
      requestOptions
    );

    return APIHandler.handleResponse(response);
  } catch (error) {
    console.error("Error fetching Zoom meetings:", error);
    throw new Error("Failed to fetch Zoom meetings");
  }
}

async function updateZoomEvent(meetingId, updateData) {
  try {
    if (!meetingId) {
      throw new Error("Meeting ID is required");
    }

    const configOptions = {
      method: "PUT",
      headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updateData),
    };

    const response = await fetch(
      `${config.oat_api_url}/manage/zoom-events/update-zoom-event/${meetingId}`,
      configOptions
    );

    return APIHandler.handleResponse(response);
  } catch (error) {
    console.error("Error updating Zoom meeting:", error);
    throw new Error("Failed to update Zoom meeting");
  }
}

async function deleteZoomEvent(meetingId) {
  try {
    if (!meetingId) {
      throw new Error("Meeting ID is required");
    }

    const configOptions = {
      method: "DELETE",
      headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      },
    };

    const response = await fetch(
      `${config.oat_api_url}/manage/zoom-events/delete-zoom-event/${meetingId}`,
      configOptions
    );

    return APIHandler.handleResponse(response);
  } catch (error) {
    console.error("Error deleting Zoom meeting:", error);
    throw new Error("Failed to delete Zoom meeting");
  }
}

async function getMembersListOfNode(nodeMid, lgUserId, lgUserTableId) {
  try {
    if (!nodeMid || !lgUserId || !lgUserTableId) {
      throw new Error("All parameters are required");
    }

    const requestOptions = {
      method: "GET",
      headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
      `${config.oat_api_url}/manage/zoom-events/getAllMembers/${nodeMid}/${lgUserId}/${lgUserTableId}`,
      requestOptions
    );

    return APIHandler.handleResponse(response);
  } catch (error) {
    console.error("Error fetching members:", error);
    throw new Error("Failed to fetch members list");
  }
}

export function formatMeetingData(rawData) {
  return {
    topic: rawData.topic || "",
    startdatetime: rawData.startdatetime || new Date().toISOString(),
    duration: parseInt(rawData.duration) || 60,
    timezone: rawData.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    node_mid: rawData.node_mid,
    create_user_id: rawData.create_user_id,
    create_user_table_id: rawData.create_user_table_id,
  };
}

export function validateMeetingData(meetingData) {
  const errors = {};

  if (!meetingData.topic || meetingData.topic.trim().length === 0) {
    errors.topic = "Meeting topic is required";
  }

  if (!meetingData.startdatetime) {
    errors.startdatetime = "Start date and time is required";
  } else {
    const startDate = new Date(meetingData.startdatetime);
    const now = new Date();
    if (startDate <= now) {
      errors.startdatetime = "Start date must be in the future";
    }
  }

  if (!meetingData.duration || meetingData.duration < 15) {
    errors.duration = "Duration must be at least 15 minutes";
  }

  if (!meetingData.timezone) {
    errors.timezone = "Timezone is required";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors: errors,
  };
}